var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.actions},[_c('div',[(_vm.row.ImagePath)?[(_vm.row.ImagePath)?_c('FormButton',{attrs:{"size":"small","type":"text","tag":"a","left-icon":"md-eye"},on:{"click":function($event){return _vm.viewImage(_vm.row.ImagePath)}}},[_vm._v("View")]):_vm._e()]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }